<template>
  <div
    class="BaseTemplateMain hide-scrollbar"
    :class="
      !hasPrinter
        ? 'q-pa-md q-pt-lg-lg q-px-lg-xl bg-off-white-10 flex-1 flex justify-center scroll'
        : 'BaseTemplateMain--printer'
    "
    @click.self="!hasPrinter && templateStore.handleActiveItem({})"
  >
    <div
      class="shadow-2 bg-white BaseTemplateMain__receipt relative-position"
      :class="[
        templateStore.isDigitalMenu
          ? [templateStore.isVertical ? 'BaseTemplateMain__digital-menu' : 'BaseTemplateMain__digital-menu--landscape']
          : '',
      ]"
      :style="`width: ${templateStore.templateWidth}px;`"
    >
      <BaseTemplateMainSection
        v-for="(layer, layerIndex) in templateStore.layers"
        :key="layerIndex"
        :layer="layer"
        :layer-index="layerIndex"
        :has-printer="hasPrinter"
      />
      <div v-if="!hasPrinter && templateStore.layoutGrid.isVisible" class="BaseTemplateMain__layout-grid">
        <span
          v-for="(column, columnIndex) in templateStore.layoutGridColumns"
          :key="columnIndex"
          class="BaseTemplateMain__layout-grid-column"
          :style="`left: ${column.left}px; width: ${column.right - column.left}px`"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTemplateStore } from 'src/stores'
import BaseTemplateMainSection from './BaseTemplateMainSection'

defineOptions({ name: 'BaseTemplateMain' })

defineProps({ hasPrinter: { type: Boolean, default: false } })

const templateStore = useTemplateStore()
</script>

<style lang="sass" scoped>
@import 'src/shared/styles/variables.sass'
@import 'src/shared/styles/mixins.sass'

.BaseTemplateMain
  padding-bottom: 101px
  @include state-modifier('printer')
    padding-bottom: 0
  @include element('receipt')
    height: fit-content

  // Drawn over the items, like Figma's layout grids; clicks pass through (see the z-index list in app.sass)
  @include element('layout-grid')
    position: absolute
    inset: 0
    z-index: 985
    pointer-events: none
  @include element('layout-grid-column')
    position: absolute
    top: 0
    bottom: 0
    background-color: rgba(255, 74, 74, 0.1)

  @include element('digital-menu')
    aspect-ratio: 9 / 16
    overflow: hidden
    @include state-modifier('landscape')
      aspect-ratio: 16 / 9
      overflow: hidden
</style>
